import {
    isObject,
    isArray,
    isFunction,
    deepMixin,
    queue
} from "../../../funcs";
import Events from "../../Events";
import RowsStorage from "../../storage/RowsStorage";
import BaseRights from "./BaseRights";
import MenuRights from "./types/MenuRights";
import MenuReportRights from "./types/MenuReportRights";
import FullGridRights from "./types/FullGridRights";
import FormGridRights from "./types/FormGridRights";
import FormRights from "./types/FormRights";
import ReportFilterRights from "./types/ReportFilterRights";
import RightsCompessor from "./RightsCompressor";


const SYS_ACL_ROLE = RowsStorage.get("SYS_ACL_ROLE");

export default class RightsManager extends Events {
    constructor(params) {
        super();

        this.queue = queue();

        params = deepMixin({}, params);
        this.params = params;

        this.initLive();

        this.rights = {
            view: {},
            edit: {}
        };

        // get current rights data
        this.loadData(() => {
            this._resetRoles();
            this.trigger("ready");
        });
    }

    loadData(callback) {
        if ( !isFunction(callback) ) {
            callback = function() {};
        }

        SYS_ACL_ROLE.get({
            filter: this._getRolesFilter()
        }, callback);
    }

    _getRolesFilter() {
        let userRolesIds = system.user.roles.map((role) => role.id);

        return {
            userRoles: {
                key: "ID",
                type: "in",
                value: userRolesIds
            }
        };
    }

    _resetRoles() {
        let rolesModels = SYS_ACL_ROLE.collection.getByParams({
            filter: this._getRolesFilter()
        });

        if ( !isArray(rolesModels) ) {
            rolesModels = [];
        }

        this.roles = rolesModels;

        this.rights = {
            view: {},
            edit: {}
        };

        rolesModels.forEach((roleModel) => {
            let compressed_json = roleModel.get("COMPRESSED_JSON");

            if ( !isObject(compressed_json) ) {
                compressed_json = {};
            }

            let decompressed_json = {
                view: RightsCompessor.decompressRights(compressed_json.view),
                edit: RightsCompessor.decompressRights(compressed_json.edit)
            };

            decompressed_json.view.forEach((rightId) => {
                this.rights.view[ rightId ] = true;
            });

            decompressed_json.edit.forEach((rightId) => {
                this.rights.edit[ rightId ] = true;
            });
        });
    }

    initLive() {
        this.listenTo(SYS_ACL_ROLE.collection, "change", () => {
            this.queue.debounce(() => {
                this._resetRoles();
                this.trigger("change");
            });
        });
    }

    getMenuRights() {
        // for Menu App
        this.menuRights = new MenuRights(this);

        return this.menuRights;
    }

    getMenuReportRights() {
        // for Menu App
        this.menuReportRights = new MenuReportRights(this);

        return this.menuReportRights;
    }

    getFullGridRights(params) {
        // журнал открытый из меню
        return new FullGridRights(this, params);
    }

    getFormRights(params) {
        return new FormRights(this, params);
    }

    getFormGridRights(params) {
        // грид в форме
        return new FormGridRights(this, params);
    }

    getReportFilterRights(params) {
        // отдельно фильтруемый грид в форме отчета
        return new ReportFilterRights(this, params);
    }

    getBaseRights(params) {
        return new BaseRights(this, params);
    }
}

RightsManager.BaseRights = BaseRights;
